/* Hard no-refresh Shopify newsletter submission. */
(function () {
  'use strict';

  if (window.__nslHardNoRefresh) return;
  window.__nslHardNoRefresh = true;

  var FORM_SELECTOR = 'form.nsl-form-row';
  var BUTTON_SELECTOR = '[data-nsl-submit-button]';

  function getForm(target) {
    if (!target) return null;
    if (target.matches && target.matches(FORM_SELECTOR)) return target;
    if (target.closest) return target.closest(FORM_SELECTOR);
    return null;
  }

  function setBusy(form, busy) {
    var button = form.querySelector(BUTTON_SELECTOR);
    form.setAttribute('aria-busy', busy ? 'true' : 'false');
    if (button) {
      button.disabled = busy;
      button.setAttribute('aria-disabled', busy ? 'true' : 'false');
    }
  }

  function setError(form, message) {
    var error = form.querySelector('[data-nsl-error]');
    if (!error) return;
    error.textContent = message || '';
    error.hidden = !message;
  }

  function showSuccess(form) {
    var wrapper = form.closest('[data-nsl-form-wrapper]');
    var card = form.closest('[data-nsl-card]');
    var success = card ? card.querySelector('[data-nsl-success]') : null;
    var disclaimer = card ? card.querySelector('[data-nsl-disclaimer]') : null;

    if (wrapper) {
      wrapper.hidden = true;
      wrapper.style.display = 'none';
    }
    if (disclaimer) {
      disclaimer.hidden = true;
      disclaimer.style.display = 'none';
    }
    if (success) {
      success.hidden = false;
      success.classList.add('is-visible');
      success.setAttribute('tabindex', '-1');
      success.focus({ preventScroll: true });
    }
  }

  function parseHtml(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function isSuccess(response, doc, formId) {
    try {
      var url = new URL(response.url, window.location.origin);
      if (url.searchParams.get('customer_posted') === 'true') return true;
    } catch (error) {}

    var returnedForm = doc.getElementById(formId);
    return Boolean(
      returnedForm &&
      returnedForm.querySelector('[data-nsl-server-status="success"]')
    );
  }

  function getResponseError(doc, formId) {
    var returnedForm = doc.getElementById(formId);
    var error = returnedForm
      ? returnedForm.querySelector('[data-nsl-error]')
      : null;
    if (error && error.textContent.trim()) return error.textContent.trim();

    var generic = doc.querySelector('.errors, [role="alert"]');
    return generic ? generic.textContent.trim() : '';
  }

  async function submitForm(form) {
    if (!form || form.dataset.nslSubmitting === 'true') return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    form.dataset.nslSubmitting = 'true';
    setBusy(form, true);
    setError(form, '');

    try {
      var response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        redirect: 'follow',
        headers: {
          Accept: 'text/html',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      var html = await response.text();
      var doc = parseHtml(html);

      if (isSuccess(response, doc, form.id)) {
        form.reset();
        showSuccess(form);
        return;
      }

      setError(
        form,
        getResponseError(doc, form.id) ||
          'Shopify could not process this subscription right now. Please try again shortly.'
      );
    } catch (error) {
      setError(
        form,
        'We could not submit your subscription right now. Please check your connection and try again.'
      );
    } finally {
      delete form.dataset.nslSubmitting;
      setBusy(form, false);
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest
        ? event.target.closest(BUTTON_SELECTOR)
        : null;
      if (!button) return;

      var form = button.form || getForm(button);
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      submitForm(form);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter') return;
      var form = getForm(event.target);
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      submitForm(form);
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form = getForm(event.target);
      if (!form) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      submitForm(form);
    },
    true
  );
})();
